export const showPDF = (imgg) => ConvertFileToBase64(imgg).then(base64Data => {
    const extractedData = base64Data.split(',')[1];
    return extractedData
}).catch(error => {
    console.error('Error:', error);
});
async function ConvertFileToBase64(fileUrl) {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    })
}